import React from 'react';
import { useTranslation } from 'react-i18next';
import { createPlaceholderUrl } from '../../../../utils/PlaceholderCreator';
import { API_BASE_URL } from '../../../../constants';

const CharacterSelector = ({ characters, selectedCharacter, onOpenModal, allCards }) => {
  const { t } = useTranslation();
  const sanitizeFilename = (name) => {
    if (typeof name !== 'string') return '';
    return name.replace(/[\\/*?:"<>|]/g, '');
  };

  if (!selectedCharacter) {
    return (
      <button
        onClick={onOpenModal}
        className="w-full bg-card-white rounded-2xl shadow-lg p-4 text-left hover:bg-gray-50 transition-colors"
      >
        <p>{t('CharacterSelector.loading')}</p>
      </button>
    );
  }

  // --- LOGICA DE IMAGEN (API) ---
  let thumbnailUrl = createPlaceholderUrl(100, 100, selectedCharacter.name_en.substring(0, 2));
  let originalCostume = null;

  // 1. Buscamos en 'allCards'
  if (selectedCharacter && allCards && allCards.length > 0) {
    originalCostume = allCards.find(c =>
      c.Id_Personaje === selectedCharacter.Id_Personaje && c.reference === 'Original'
    );
  }

  // 2. Si se encuentra, construimos la URL usando la API
  if (originalCostume) {
    try {
      const characterName = sanitizeFilename(selectedCharacter.name_en).replace(/ /g, '_');
      const reference = sanitizeFilename(originalCostume.reference).replace(/ /g, '_');
      const costumeName = sanitizeFilename(originalCostume.title_en).replace(/ /g, '_');

      const imageName = `${characterName}_${reference}_${costumeName}.png`;
      const originalPath = `/images/character/${imageName}`;

      // Usamos width=64 ya que el CSS usa w-16 (64px)
      thumbnailUrl = `${API_BASE_URL}/api/thumb?img=${originalPath}&width=64`;
    } catch (error) {
      console.error("Could not construct thumbnail URL for:", selectedCharacter.name_en, error);
    }
  }
  // --- FIN DE LA LÓGICA DE IMAGEN ---

  return (
    <button
      onClick={onOpenModal}
      className="w-full bg-card-white rounded-2xl shadow-lg p-4 text-left hover:bg-gray-50 transition-colors"
    >
      <div className="flex items-center space-x-4">

        {/* --- INICIO DE LA ESTRUCTURA ESTABLE --- */}
        {/* Volvemos a un <img> simple. */}
        {/* Añadimos object-cover y object-top para un mejor encuadre sin zoom */}
        <img
          src={thumbnailUrl}
          alt={selectedCharacter.name_en}
          className="w-16 h-16 rounded-full shadow-md object-cover object-top"
        />
        {/* --- FIN DE LA ESTRUCTURA ESTABLE --- */}

        <div>
          <h2 className="text-2xl font-bold text-gray-800">{selectedCharacter.name_en}</h2>
          <p className="text-secondary-blue font-medium">{t('CharacterSelector.change_label', { count: characters.length })}</p>
        </div>
      </div>
    </button>
  );
};

export default CharacterSelector;
// Revisado: 2025-12-18 [I18n Scan]